import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeAheadHighlight',
  standalone: true,
})
export class TypeAheadHighlightPipe implements PipeTransform {
  transform(matchItem: string, searchTerm: string): string {
    const pattern = this.escapeRegexp(searchTerm);
    return searchTerm ? `${matchItem}`.replace(new RegExp(pattern, 'gi'), '<strong>$&</strong>') : matchItem;
  }

  private escapeRegexp(queryToEscape: string) {
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  }
}
